import './tou.css';

function TermsOfUse() {

    return (
      <div>
        <h4>Terms of Use</h4>
        <div className="left-align-section">
          <h4>1. Use of the Website</h4>
          <ol className="toupp">
            <li>
              <b>Eligibility:</b> You must be at least 13 years old to use the Website. By using the Website, you represent
              and warrant that you are at least 13 years old.
            </li>
            <li>
              <b>Permitted Use:</b> You may use the Website for lawful purposes only. You may not use the Website:
              <ul className="toupp">
                <li>In any way that violates any applicable federal, state, local, or international law or regulation.</li>
                <li>
                  To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail,"
                  "chain letter," "spam," or any other similar solicitation.
                </li>
                <li>
                  To impersonate or attempt to impersonate Astronomyshare.com, an Astronomyshare.com employee, another user,
                  or any other person or entity.
                </li>
                <li>
                  To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Website, or
                  which, as determined by us, may harm Astronomyshare.com or users of the Website or expose them to liability.
                </li>
              </ul>
            </li>
            <li>
              <b>User Content:</b> The Website may allow you to submit, upload, publish, or otherwise make available content,
              such as comments, reviews, photos, and videos ("User Content"). You retain all rights in, and are solely
              responsible for, the User Content you submit. By submitting User Content, you grant Astronomyshare.com a
              non-exclusive, royalty-free, worldwide, perpetual, irrevocable, and sublicensable right to use, reproduce, modify,
              adapt, publish, translate, create derivative works from, distribute, perform, and display such User Content in any
              media.
            </li>
            <li>
              <b>Prohibited Content:</b> You may not submit any User Content that:
              <ul className="toupp">
                <li>
                  Is unlawful, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, libelous,
                  invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.
                </li>
                <li>Infringes any patent, trademark, trade secret, copyright, or other proprietary rights of any party.</li>
                <li>Contains any viruses, worms, defects, Trojan horses, or other items of a destructive nature.</li>
                <li>
                  Impersonates any person or entity or falsely states or otherwise misrepresents your affiliation with a
                  person or entity.
                </li>
              </ul>
            </li>
          </ol>
  
          <h4>2. Intellectual Property</h4>
          <ol className="toupp">
            <li>
              <b>Ownership:</b> The Website and its entire contents, features, and functionality (including but not limited to
              all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement
              thereof) are owned by Astronomyshare.com, its licensors, or other providers of such material and are protected by
              United States and international copyright, trademark, patent, trade secret, and other intellectual property or
              proprietary rights laws.
            </li>
            <li>
              <b>Limited License:</b> These Terms permit you to use the Website for your personal, non-commercial use only.
              You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform,
              republish, download, store, or transmit any of the material on our Website, except as follows:
              <ul className="toupp">
                <li>Your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials.</li>
                <li>You may store files that are automatically cached by your Web browser for display enhancement purposes.</li>
                <li>You may print or download one copy of a reasonable number of pages of the Website for your own personal, non-commercial use and not for further reproduction, publication, or distribution.</li>
              </ul>
            </li>
            <li>
              <b>Trademarks:</b> The Astronomyshare.com name and logo, and all related names, logos, product and service
              names, designs, and slogans are trademarks of Astronomyshare.com or its affiliates or licensors. You must not use
              such marks without the prior written permission of Astronomyshare.com.
            </li>
          </ol>
  
          <h4>3. Disclaimer</h4>
          <p>
            THE WEBSITE AND ITS CONTENT ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. IN
            NO EVENT WILL ASTRONOMYSHARE.COM, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
            OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION
            WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER
            WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT
            LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF
            BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING
            NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.
          </p>
  
          <h4>4. Limitation of Liability</h4>
          <p>
            IN NO EVENT WILL ASTRONOMYSHARE.COM'S LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER IN
            CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE) EXCEED THE AMOUNT YOU PAID TO ASTRONOMYSHARE.COM, IF ANY, FOR
            ACCESSING THE WEBSITE.
          </p>
  
          <h4>5. Indemnification</h4>
          <p>
            You agree to defend, indemnify, and hold harmless Astronomyshare.com, its affiliates, licensors, and service
            providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers,
            successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs,
            expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your breach of these Terms or
            your use of the Website, including, but not limited to, your User Content, any use of the Website's content,
            services, and products other than as expressly authorized in these Terms, or your use of any information obtained
            from the Website.
          </p>
  
          <h4>6. Governing Law and Jurisdiction</h4>
          <p>
            All matters relating to the Website and these Terms and any dispute or claim arising therefrom or related thereto
            (in each case, including non-contractual disputes or claims), shall be governed by and construed in accordance with
            the internal laws of the State of [Your State], without giving effect to any choice or conflict of law provision or
            rule (whether of the State of [Your State] or any other jurisdiction).
          </p>
          <p>
            Any legal suit, action, or proceeding arising out of, or related to, these Terms or the Website shall be instituted
            exclusively in the federal courts of the United States or the courts of the State of [Your State] in each case
            located in [Your City, State]. You waive any and all objections to the exercise of jurisdiction over you by such
            courts and to venue in such courts.
          </p>
  
          <h4>7. Termination</h4>
          <p>
            Astronomyshare.com may terminate your access to all or any part of the Website at any time, with or without cause,
            with or without notice, effective immediately. If you wish to terminate this Agreement or your Astronomyshare.com
            account (if you have one), you may simply discontinue using the Website.
          </p>
  
          <h4>8. Entire Agreement</h4>
          <p>
            These Terms constitute the entire agreement between you and Astronomyshare.com with respect to the Website and
            supersede all prior or contemporaneous communications and proposals, whether electronic, oral, or written, between
            you and Astronomyshare.com with respect to the Website.
          </p>
  
          <h4>9. Changes to These Terms</h4>
          <p>
            Astronomyshare.com reserves the right to modify these Terms at any time in its sole discretion. If we make material
            changes to these Terms, we will post the updated Terms on the Website and update the "Last Updated" date at the top
            of this page. Your continued use of the Website following the posting of revised Terms means that you accept and
            agree to the changes.
          </p>
  
          <h4>10. Contact Us</h4>
        <p>
          If you have any questions about these Terms, please contact us at jfrabell@yahoo.com
        </p>
      </div>
    </div>
  );
}

export default TermsOfUse;